<template>
<div class="chapter">
<div class="inner_page">
<p class="prect" id="contents"><a id="pVI"></a><a id="pVII"></a>CONTENTS</p>
<p class="contents-"><a href="#/preface.htm#pref">Preface</a></p>
<p class="contents"><a href="#/note_on_conventions.htm#conven">Note on Conventions</a></p>
<p class="contents-pt"><a href="#/part_01.htm#part1">PART I  YOUNG CHARLES</a></p>
<p class="contents-ct"><a href="#/chapter_01.htm#chap1"><span class="contentblock">  1 </span>From Duke of Luxemburg to Prince of Castile, 1500–8</a></p>
<p class="contents-ct"><a href="#/chapter_02.htm#chap2"><span class="contentblock">  2 </span>The Orphan Prince, 1509–14</a></p>
<p class="contents-ct"><a href="#/chapter_03.htm#chap3"><span class="contentblock">  3 </span>The Difficult Inheritance, 1515–17</a></p>
<p class="contents-ct1"><a href="#/portrait_01.htm#portrait1"><i>Portrait of the Emperor as a Young Man</i></a></p>
<p class="contents-pt"><a href="#/part_02.htm#part2">PART II  GAME OF THRONES</a></p>
<p class="contents-ct"><a href="#/chapter_04.htm#chap4"><span class="contentblock">  4 </span>From King of Spain to King of the Romans, 1517–19</a></p>
<p class="contents-ct"><a href="#/chapter_05.htm#chap5"><span class="contentblock">  5 </span>From Peace through Rebellion to War, 1519–21</a></p>
<p class="contents-ct"><a href="#/chapter_06.htm#chap6"><span class="contentblock">  6 </span>Snatching Victory from the Jaws of Defeat, 1521–5</a></p>
<p class="contents-ct"><a href="#/chapter_07.htm#chap7"><span class="contentblock">  7 </span>Snatching Defeat from the Jaws of Victory, 1525–8</a></p>
<p class="contents-ct"><a href="#/chapter_08.htm#chap8"><span class="contentblock">  8 </span>Champion of the Western World, 1528–31</a></p>
<p class="contents-ct1"><a href="#/portrait_02.htm#portrait2"><i>Portrait of the Emperor as a Renaissance Prince</i></a></p>
<p class="contents-pt"><a href="#/part_03.htm#part3">PART III  ‘RULER FROM THE RISING TO THE SETTING <br/>OF THE SUN’</a></p>
<p class="contents-ct"><a href="#/chapter_09.htm#chap9"><span class="contentblock">  9 </span>The Last Crusader, 1532–6</a></p>
<p class="contents-ct"><a href="#/chapter_10.htm#chap10"><span class="contentblock">10 </span>Years of Defeat, 1536–41</a></p>
<p class="contents-ct"><a href="#/chapter_11.htm#chap11"><span class="contentblock">11 </span>Settling Scores, Part I: Guelders and France, 1541–4</a></p>
<p class="contents-ct"><a href="#/chapter_12.htm#chap12"><span class="contentblock">12 </span>Settling Scores, Part II: Germany and Italy, 1545–8</a></p>
<p class="contents-ct"><a href="#/chapter_13.htm#chap13"><span class="contentblock">13 </span>The Taming of America</a></p>
<p class="contents-ct1"><a href="#/portrait_03.htm#portrait3"><i>Portrait of the Emperor in his Prime</i></a></p>
<p class="contents-pt"><a id="pVIII"></a><a href="#/part_04.htm#part4">PART  IV DOWNFALL</a></p>
<p class="contents-ct"><a href="#/chapter_14.htm#chap14"><span class="contentblock">14 </span>Paterfamilias, 1548–51</a></p>
<p class="contents-ct"><a href="#/chapter_15.htm#chap15"><span class="contentblock">15 </span>The Emperor’s Last Campaigns, 1551–4</a></p>
<p class="contents-ct"><a href="#/chapter_16.htm#chap16"><span class="contentblock">16 </span>Restless Retirement, 1555–8</a></p>
<p class="contents-ct"><a href="#/chapter_17.htm#chap17"><span class="contentblock">17 </span>The Emperor in Legend and History</a></p>
<p class="contents-ct1"><a href="#/epilogue.htm#epilo">Epilogue: The Balance of the Reign</a></p>
<p class="contents-ct2"><a href="#/appendices.htm#app">Appendices:</a></p>
<p class="contents-a"><a href="#/appendices.htm#app1">I. The Emperor’s <i>Memoirs</i></a></p>
<p class="contents-a"><a href="#/appendices.htm#app2">II. The Afterlife of Charles V’s Body</a></p>
<p class="contents-a"><a href="#/appendices.htm#app3">III. The Emperor’s Last Instructions to Philip II</a></p>
<p class="contents-a"><a href="#/appendices.htm#app4">IV. ‘Infanta Isabel of Castile, daughter of His <br/>Majesty the emperor’</a></p>
<p class="contents"><a href="#/acknowledgements.htm#ack">Acknowledgements</a></p>
<p class="contents"><a href="#/chronology.htm#chrono">Chronology</a></p>
<p class="contents"><a href="#/abbreviations.htm#abbrev">Abbreviations in the Notes and Sources</a></p>
<p class="contents"><a href="#/note_on_dates_and_quotes.htm#dates">Note on Dates and Quotes</a></p>
<p class="contents"><a href="#/note_on_sources.htm#sources">Note on Sources</a></p>
<p class="contents"><a href="#/notes.htm#notes">Notes</a></p>
<p class="contents"><a href="#/bibliography.htm#biblio">Bibliography</a></p>
<p class="contents"><a href="#/list_of_maps_figures_and_plates.htm#list">List of Maps, Figures and Plates</a></p>
<p class="contents"><a href="#/index.htm#index">Index</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?ae09939a